import {
	Slider,
	type SliderProps,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import type { FC, ReactNode } from "react";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

type Props = Pick<SliderProps, "min" | "max" | "step"> & {
	icon: ReactNode;
	label: string;
	valueLabel: string;
	value: number;
	onChange: (value: number) => void;
	minLabel: string;
	maxLabel: string;
};

export const LoanCalculatorSliderRow: FC<Props> = ({
	icon,
	label,
	valueLabel,
	value,
	onChange,
	min,
	max,
	step,
	minLabel,
	maxLabel,
}) => {
	const theme = useTheme();

	return (
		<Stack
			px={1.6}
			py={1.2}
			borderBottom={`1px solid ${theme.palette.grey[100]}`}
		>
			<LabeledValueRow
				label={
					<Stack direction="row" alignItems="center" gap={1}>
						{icon}
						<Typography variant="bodyMedium" color={theme.palette.grey[900]}>
							{label}
						</Typography>
					</Stack>
				}
				value={
					<Typography
						variant="bodyStrong"
						color={theme.palette.primary.main}
						tabular
					>
						{valueLabel}
					</Typography>
				}
			/>
			<Slider
				variant="flat"
				value={value}
				onChange={(_, v) => onChange(typeof v === "number" ? v : v[0])}
				min={min}
				max={max}
				step={step}
			/>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="hint">{minLabel}</Typography>
				<Typography variant="hint">{maxLabel}</Typography>
			</Stack>
		</Stack>
	);
};
